export class PriceRuleTypeReferenceModel {
    public priceRuleTypeCode: string;
    public priceRuleTypeName: string;
    public sortSequence: number;
}